import {
  Button,
  CircularProgress,
  TableCell,
  TableRow,
  Typography,
} from "@mui/material";

import { NewTabLink } from "components/NewTabLink";

import type { MyCarrierItem } from "./types";

interface Props {
  item: MyCarrierItem;
  onRemove: (item: MyCarrierItem) => void;
  removing: boolean;
}

export function ShipperNetworkTableRow(props: Props) {
  const { item, onRemove, removing } = props;
  const contactName = `${item.user.first_name} ${item.user.last_name}`.trim();

  let companyCell: JSX.Element;
  if (item.kind === "invite") {
    companyCell = (
      <Typography variant="body1" color="text.secondary">
        -
      </Typography>
    );
  } else if (item.company) {
    companyCell = (
      <NewTabLink href={`/companies/${item.company.id}/profile`}>
        <Typography variant="body1">{item.company.name}</Typography>
      </NewTabLink>
    );
  } else {
    companyCell = (
      <Typography variant="body1" color="text.secondary">
        No company created yet
      </Typography>
    );
  }

  return (
    <TableRow>
      <TableCell>
        <Typography variant="body1">{contactName}</Typography>
      </TableCell>
      <TableCell>{companyCell}</TableCell>
      <TableCell>
        <Typography variant="body2">
          {new Date(item.created_at).toLocaleDateString()}
        </Typography>
      </TableCell>
      <TableCell>
        <Button
          variant="outlined"
          size="small"
          disabled={removing}
          onClick={() => onRemove(item)}
          startIcon={
            removing ? <CircularProgress size={14} color="inherit" /> : null
          }
        >
          Remove from Network
        </Button>
      </TableCell>
    </TableRow>
  );
}
